export class ReservationHotelRoomDetailsModel {
    constructor(data = {}, hotels = [], hotelMessages = []) {
        this.PropertyId = data?.PropertyId ?? null;
        this.PropertyCode = data?.PropertyCode ?? null;
        this.PropertyName = data?.PropertyName ?? null;
        this.StarRating = data?.StarRating ?? 0;
        this.ContractCode = data?.ContractCode ?? null;
        this.ContractId = data?.ContractId ?? null;
        this.LocationId  = data?.LocationId  ?? null;
        this.ClientCurrency = data?.ClientCurrency ?? null;
        this.Description = data?.Description ?? null;
        this.HotelMessage = hotelMessages;
        this.CancellationPolicy = {
            CheckIn: data?.CancellationPolicy?.CheckIn ?? null,
            Description: data?.CancellationPolicy?.Description ?? null,
            Details: Array.isArray(data?.CancellationPolicy?.Details)
                ? [...data.CancellationPolicy.Details]
                : [],
            RoomRateOnly: data?.CancellationPolicy?.RoomRateOnly ?? false
        };
        this.RoomRequests = data?.RoomRequestResults?.map((roomRequest) => {
            const groupedRooms = roomRequest.Rooms?.reduce((acc, room) => {
                acc[room.RateType] = acc[room.RateType] ?? [];
                acc[room.RateType].push(room);
                return acc;
            }, {}) ?? {};

            return {
                roomRequestId: roomRequest.RoomRequestId,
                groupedRooms,
            };
        }) ?? [];
        this.SelectedHotel = hotels.find(h => h.PropertyId === this.PropertyId) ?? null;
    }
}